function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoicemailNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.9,8.85a1.31,1.31,0,0,0-1.07.64,2.63,2.63,0,0,0-.35,1.36c.11,1.2,1.54,2.2,2.36,2.74,7.71,5.23,5.78,5.64,11.63,1.43,1.28-.93,3.07-1.86,3.85-3a2.27,2.27,0,0,0,.15-2.64c-.58-.64-1.08-.56-1.94-.56H8.59A15.89,15.89,0,0,0,6.9,8.85Z",
    style: {
      fill: "#eac282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.67,23a3,3,0,0,0-2.14-.93,3.17,3.17,0,0,0-3.14,3.15,3,3,0,0,0,.42,1.63H18.53A4,4,0,0,0,19,25.28,3.13,3.13,0,0,0,13.61,23a3.39,3.39,0,0,0-.86,2.24,3.2,3.2,0,0,0,.86,2.14,3.06,3.06,0,0,0,2.24.93h7.68a3.12,3.12,0,0,0,3-3.2,3.21,3.21,0,0,0-.9-2.11ZM17,26.26a1.63,1.63,0,0,1-1.15.49,1.7,1.7,0,0,1-1.57-1.57,1.62,1.62,0,0,1,1.57-1.59A1.54,1.54,0,0,1,17.51,25,1.51,1.51,0,0,1,17,26.26Zm7.56,0a1.42,1.42,0,0,1-1.07.49,1.5,1.5,0,0,1-1.14-.49,1.4,1.4,0,0,1-.43-1.08,1.51,1.51,0,0,1,1.4-1.59h.17a1.51,1.51,0,0,1,1.07.43A1.57,1.57,0,0,1,25,25.18a1.6,1.6,0,0,1-.45,1.08Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,23.26h-.07a2.93,2.93,0,0,0-.81-1.07,4.29,4.29,0,0,0-3-1.29,4.38,4.38,0,0,0-3,1.29,4.14,4.14,0,0,0-.75,1.07H7.18A1.62,1.62,0,0,1,5.54,22a7.93,7.93,0,0,1-.06-1.38V13.48c1.42,1.34,7.77,5.84,9.2,5.84s7.71-4.5,9.14-5.85v7.38h0A4.31,4.31,0,0,0,20,23.26Z",
    style: {
      fill: "#eac282"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicemailNormal);
export default __webpack_public_path__ + "static/media/voicemail-normal.f447c293.svg";
export { ForwardRef as ReactComponent };